/* PastéBCN — Accordion item
   Web Component <pb-accordion-item>:
   - Toggle con animación de max-height (NUNCA display:none → SEO).
   - Soporta data-default-open="true" para arrancar abierto.
   - Cambia data-expanded en el host, aria-expanded en el trigger,
     aria-hidden en el panel, y el texto del label (data-expand-label
     / data-collapse-label).
   - ESC cierra cuando tiene foco dentro.
   - Sobrevive a shopify:section:load. */

if (!customElements.get('pb-accordion-item')) {
  class PbAccordionItem extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-accordion-trigger]');
      this.panel = this.querySelector('[data-accordion-panel]');
      this.label = this.querySelector('[data-accordion-label]');

      if (!this.trigger || !this.panel) return;

      this._onClick = this._onClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);

      this.trigger.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown);

      const defaultOpen = this.dataset.defaultOpen === 'true';
      if (defaultOpen) this.expand({ instant: true });
      else this._setCollapsedAttributes();
    }

    disconnectedCallback() {
      if (this.trigger) this.trigger.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeydown);
    }

    _onClick(e) {
      e.preventDefault();
      this.toggle();
    }

    _onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        if (this.dataset.expanded === 'true') {
          this.collapse();
          this.trigger.focus();
        }
      }
    }

    toggle() {
      if (this.dataset.expanded === 'true') this.collapse();
      else this.expand();
    }

    expand({ instant = false } = {}) {
      this.dataset.expanded = 'true';
      this.trigger.setAttribute('aria-expanded', 'true');
      this.panel.setAttribute('aria-hidden', 'false');
      this._setLabel('collapse');

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (instant || reducedMotion) {
        this.panel.style.maxHeight = 'none';
        return;
      }
      this.panel.style.maxHeight = this.panel.scrollHeight + 'px';
      const onEnd = (evt) => {
        if (evt && evt.propertyName !== 'max-height') return;
        if (this.dataset.expanded === 'true') {
          this.panel.style.maxHeight = 'none';
        }
        this.panel.removeEventListener('transitionend', onEnd);
      };
      this.panel.addEventListener('transitionend', onEnd);
    }

    collapse() {
      this.dataset.expanded = 'false';
      this.trigger.setAttribute('aria-expanded', 'false');
      this.panel.setAttribute('aria-hidden', 'true');
      this._setLabel('expand');

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) {
        this.panel.style.maxHeight = '0';
        return;
      }
      /* Si está en 'none', primero fijamos a scrollHeight para tener
         valor del que animar, luego forzamos reflow y reseteamos a 0. */
      this.panel.style.maxHeight = this.panel.scrollHeight + 'px';
      void this.panel.offsetHeight;
      this.panel.style.maxHeight = '0';
    }

    _setLabel(state) {
      if (!this.label) return;
      const expandText = this.label.dataset.expandLabel;
      const collapseText = this.label.dataset.collapseLabel;
      if (state === 'expand' && expandText) this.label.textContent = expandText;
      if (state === 'collapse' && collapseText) this.label.textContent = collapseText;
    }

    _setCollapsedAttributes() {
      this.dataset.expanded = 'false';
      this.trigger.setAttribute('aria-expanded', 'false');
      this.panel.setAttribute('aria-hidden', 'true');
      this.panel.style.maxHeight = '0';
    }
  }

  customElements.define('pb-accordion-item', PbAccordionItem);
}
